import { api } from '@/lib/api.js';

// THE PERSON EDIT DOOR (people-create-door C1, ruling 1): a person's name,
// preferred name, email and main phone are edited in TRACON, never in CRM.
// The body is sparse (only what changed); the answer is the person read back,
// with `warnings` for one toast.info each. Keyed on the Contact id.
export function editPersonIdentity(contactId, body) {
  return api.patch(`/api/tracon/person/${encodeURIComponent(contactId)}/identity`, body);
}

// The person edit form's read (people-create-door C4): the person as the one
// identity reader holds it, in the edit door's own words ({ store, person }),
// so the form derives nothing. Broker token only; a failed read is 503.
export function getPersonIdentity(contactId) {
  return api.get(`/api/tracon/person/${encodeURIComponent(contactId)}/identity?_t=${Date.now()}`);
}

// THE OTHER-NUMBER DOORS (people-create-door C2, ruling 2: more numbers carry a
// label), "both" only: the server answers 409 people_not_authoritative in zoho
// mode. Each answers the person read back ({ person }, its other_phones the
// server's) with `warnings` for one toast.info each. Keyed on the Contact id.
export function addPersonPhone(contactId, { phone, label }) {
  return api.post(`/api/tracon/person/${encodeURIComponent(contactId)}/phones`, { phone, label });
}

export function relabelPersonPhone(contactId, phoneId, { label }) {
  return api.patch(`/api/tracon/person/${encodeURIComponent(contactId)}/phones/${encodeURIComponent(phoneId)}`, { label });
}

// Retired, never deleted; the reason is required.
export function retirePersonPhone(contactId, phoneId, { reason }) {
  return api.post(`/api/tracon/person/${encodeURIComponent(contactId)}/phones/${encodeURIComponent(phoneId)}/retire`, { reason });
}

// The number becomes the main; the old main stays as another number.
export function promotePersonPhone(contactId, phoneId) {
  return api.post(`/api/tracon/person/${encodeURIComponent(contactId)}/phones/${encodeURIComponent(phoneId)}/promote`, {});
}

// THE "MAKE A PERSON" DOOR (people-create-door C8, AR12): a contact-less roster
// pilot becomes a person through the existing fix-pilot door (broker only),
// keyed on the form's own session; the body carries the form token, the name
// (required) and the email and phone (optional). Answers the Contact it made.
export function makePerson(sessionToken, body) {
  return api.post(`/api/session/${encodeURIComponent(sessionToken)}/fix-pilot`, body);
}
